import type { MessengerStory } from "@/lib/api";
import MessengerStoryCard from "./MessengerStoryCard";

type Props = {
  stories: MessengerStory[];
  isLoading: boolean;
  indexExists: boolean;
  onOpenProfile: (participantId: string) => void;
};

export default function MessengerStoryList({
  stories,
  isLoading,
  indexExists,
  onOpenProfile,
}: Props) {
  if (!indexExists) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900">
        Brak danych historii na serwerze. Skontaktuj się z Arek, żeby odświeżyć indeks.
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-32 animate-pulse rounded-xl border border-slate-200 bg-white"
          />
        ))}
      </div>
    );
  }

  if (stories.length === 0) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center">
        <p className="text-sm font-medium text-slate-700">Brak wyników</p>
        <p className="mt-1 text-sm text-slate-500">
          Zmień filtry lub wyczyść wyszukiwanie.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {stories.map((story) => (
        <MessengerStoryCard key={story.story_id} story={story} onOpenProfile={onOpenProfile} />
      ))}
    </div>
  );
}
